
import { defineComponent } from 'vue';
import { useTheme } from '../composables/useTheme';

export default defineComponent({
  name: 'ThemeToggle',
  setup() {
    const { themePreference, setTheme } = useTheme();

    const options = [
      { mode: 'system' as const, label: 'System theme' },
      { mode: 'light' as const, label: 'Light theme' },
      { mode: 'dark' as const, label: 'Dark theme' },
    ];

    return { themePreference, setTheme, options };
  },
});
